import React from "react";
import { DocumentosSetoriaisPage } from "./documentosSetoriais.page";
import { DocumentosSetoriaisProvider } from "./context/documentos-setoriais-context";

export function DocumentosSetoriaisFactory() {
    return (
        <DocumentosSetoriaisProvider>
            <DocumentosSetoriaisPage></DocumentosSetoriaisPage>
        </DocumentosSetoriaisProvider>
    );
}
